module.exports = __webpack_public_path__ + "static/media/bootcamp-bar-icon.cdf305a2.svg";